module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 41
// module chunks = 0